//import createSwiper from '../utils/swiper';
import Swiper from 'swiper/bundle';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import scroll from '../utils/scroll';

// Importation de LocomotiveScroll pour utiliser directement l'instance créée
import LocomotiveScroll from 'locomotive-scroll';

gsap.registerPlugin(ScrollTrigger);

const activites = {
    init() {
        this.initSwipers();
        this.initProgramme();
    },
    initSwipers() {
        const swiper_annonces = new Swiper('.__galerie_swipe', {
            direction: 'horizontal',
            spaceBetween: 30,
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                },
                600: {
                    slidesPerView: 1.4,
                },
                900: {
                    slidesPerView: 2.3,
                },
                1300: {
                    slidesPerView: 2.5,
                }
            }
        });
    },
    initProgramme() {
        $(document).on("click", "._programme > h3", function () {
            let _elt = $(this).parent();
            _elt.toggleClass("_open");
            $("._programme").not(_elt).removeClass("_open");
        });
    }
};

export default activites;
